// Free soap on orders of ₹2,999+ (see snippets/free-gift.liquid).
// Watches every cart change (theme forms, BUY NOW, the YourToken cart) and keeps exactly one
// gift in the cart while the rest of the cart is at or above the threshold. The Buy X Get Y
// discount is what makes the gift ₹0.
(function () {
  const config = window.freeGift;
  if (!config) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const giftIds = config.gifts.map((gift) => gift.id);
  const cartChangePattern = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  // Marks our own cart requests so the watcher doesn't react to them.
  const ownMarker = 'free_gift=1';
  // Set when an added gift wasn't ₹0 (discount inactive): stop adding on this page.
  let discountInactive = false;

  // Remembers, per cart, that we added the gift and whether the customer removed it themselves.
  const storageKey = 'freeGiftState';
  function readState() {
    try {
      return JSON.parse(localStorage.getItem(storageKey)) || {};
    } catch (error) {
      return {};
    }
  }
  function writeState(state) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (error) {
      // Private mode etc. — the offer still works, it just can't remember a removal.
    }
  }

  function isGift(item) {
    return giftIds.includes(item.variant_id);
  }

  // Shopify's Buy X Get Y only counts lines that have no other product discount (sale items
  // don't count), so mirror that: a line counts only if none of its discounts take money off.
  function counts(item) {
    return !isGift(item) && item.line_level_discount_allocations.every((allocation) => allocation.amount === 0);
  }

  function qualifyingTotal(cart) {
    return cart.items.filter(counts).reduce((sum, item) => sum + item.final_line_price, 0);
  }

  async function getCart() {
    const response = await window.fetch(`${root}cart.js`, { credentials: 'same-origin' });
    return response.json();
  }

  function post(path, body) {
    return window.fetch(`${root}${path}?${ownMarker}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  // Tries each gift in priority order; returns the one added, or null if all are sold out.
  async function addGift() {
    for (const gift of config.gifts) {
      if (!gift.available) continue;
      const response = await post('cart/add.js', { items: [{ id: gift.id, quantity: 1 }] });
      if (response.ok) return gift;
      gift.available = false;
    }
    return null;
  }

  async function evaluate() {
    const cart = await getCart();
    const state = readState();
    if (state.token !== cart.token) {
      state.token = cart.token;
      state.added = false;
      state.declined = false;
    }

    const earned = qualifyingTotal(cart) >= config.threshold;
    const giftLines = cart.items.filter(isGift);
    const updates = {};
    let added = null;

    if (!earned) {
      giftLines.forEach((item) => (updates[item.key] = 0));
      state.added = false;
    } else if (giftLines.length > 0) {
      giftLines.forEach((item, index) => {
        if (index > 0) updates[item.key] = 0;
        else if (item.quantity > 1) updates[item.key] = 1;
      });
    } else if (state.added) {
      // We added it earlier and it's gone while still earned: the customer removed it.
      state.declined = true;
    } else if (!state.declined && !discountInactive) {
      added = await addGift();
      if (added) state.added = true;
    }

    if (Object.keys(updates).length > 0) await post('cart/update.js', { updates });

    const changed = Boolean(added) || Object.keys(updates).length > 0;
    let latest = changed ? await getCart() : cart;

    // Never leave a "free" soap in the cart at full price.
    const chargedGift = latest.items.find((item) => isGift(item) && item.final_line_price > 0);
    if (chargedGift) {
      await post('cart/update.js', { updates: { [chargedGift.key]: 0 } });
      if (added) discountInactive = true;
      added = null;
      state.added = false;
      latest = await getCart();
    }

    writeState(state);
    if (changed || chargedGift) await refreshCartUI();
    if (added) showToast(`Surprise! A free ${added.name} has been added to your cart.`);
    updateNudge(latest);
    return latest;
  }

  // Runs evaluations one after another so two cart changes can never add two gifts.
  let queue = Promise.resolve();
  function enqueue() {
    queue = queue.then(evaluate, evaluate).catch((error) => console.error('Free gift error:', error));
    return queue;
  }

  let timer;
  function scheduleEvaluate() {
    clearTimeout(timer);
    timer = setTimeout(enqueue, 400);
  }

  // Shows the gift (or its removal) in whichever cart is on the page.
  // The YourToken cart refreshes itself when it sees a cart request (ours go through its fetch
  // wrapper too), so only the theme's cart count needs updating here.
  async function refreshCartUI() {
    try {
      const response = await window.fetch(`${root}?sections=cart-icon-bubble`);
      const sections = await response.json();
      const bubble = document.getElementById('cart-icon-bubble');
      const html = sections['cart-icon-bubble'];
      if (bubble && html) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }
    } catch (error) {
      // The count catches up on the next page load.
    }
  }

  function showToast(message) {
    const toast = document.createElement('div');
    toast.className = 'free-gift-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 400);
    }, 5000);
  }

  function updateNudge(cart) {
    if (!config.showNudge) return;
    const nudge = document.querySelector('[data-free-gift-nudge]');
    if (!nudge) return;

    const remaining = config.threshold - qualifyingTotal(cart);
    const nextGift = config.gifts.find((gift) => gift.available);
    if (cart.items.some(isGift)) {
      nudge.innerHTML = '<strong>Your free soap is in the cart.</strong>';
    } else if (remaining > 0 && nextGift) {
      const amount = Math.ceil(remaining / 100).toLocaleString('en-IN');
      nudge.innerHTML = `Add <strong>₹${amount}</strong> more to get a <strong>free soap</strong>.`;
    } else {
      nudge.innerHTML = '';
    }
    nudge.hidden = nudge.innerHTML === '';
  }

  // Watch every cart change on the page, whichever script made it (theme, BUY NOW, YourToken):
  // finished network requests show up here even when an app kept its own copy of fetch.
  if ('PerformanceObserver' in window) {
    new PerformanceObserver((list) => {
      const cartChanged = list
        .getEntries()
        .some((entry) => cartChangePattern.test(entry.name) && !entry.name.includes(ownMarker));
      if (cartChanged) scheduleEvaluate();
    }).observe({ type: 'resource' });
  }

  // BUY NOW skips the cart: it calls this and waits before going to checkout.
  config.evaluate = enqueue;

  // A cart from an earlier visit may have crossed (or dropped below) the threshold.
  enqueue();
})();
